import apiClient from '../client';
import { SewingReportFilter, SewingReportData } from '@shared/types';

export const sewingReportService = {
  /**
   * Generate sewing report
   */
  getReport: async (filter: SewingReportFilter): Promise<SewingReportData[]> => {
    const response: any = await apiClient.post('/sewing-report', filter);
    return response.data;
  },
};
